var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":"","id":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }